<script setup lang="ts">
type Props = {
    for?: string;
    required?: boolean;
};

const props = defineProps<Props>();
</script>
<template>
    <label class="font-display font--bold inline-flex text-sm" :for="props.for">
        <slot />
        <span v-if="required" class="text-red-500" v-tooltip.right="'Required field'">*</span>
    </label>
</template>
